import { inject, Injectable } from '@angular/core';
import { tap } from 'rxjs';

import {
  CreateSiteBudgetVersionInput,
  EntityType,
  GqlService,
  NoteType,
} from '@shared/services/gql.service';
import { OverlayService } from '@shared/services/overlay.service';
import { isDuplicateError } from '@shared/utils';
import { Utils } from '@shared/utils/utils';

@Injectable({ providedIn: 'root' })
export class SiteBudgetService {
  private gqlService = inject(GqlService);
  private overlayService = inject(OverlayService);

  createNote$(note: string, siteBudgetId: string) {
    return this.gqlService
      .createNote$({
        entity_id: siteBudgetId,
        entity_type: EntityType.SITE_BUDGET_VERSION,
        message: Utils.scrubUserInput(note),
        note_type: NoteType.NOTE_TYPE_GENERAL,
      })
      .pipe(
        tap(({ errors }) => {
          if (errors.length) {
            this.overlayService.error(errors);
          }
        })
      );
  }

  createSiteBudgetVersion$(params: CreateSiteBudgetVersionInput) {
    return this.gqlService.createSiteBudgetVersion$(params).pipe(
      tap(({ errors }) => {
        const errorsWithoutDuplicateError = errors.filter((error) => !isDuplicateError(error));

        if (errorsWithoutDuplicateError.length) {
          this.overlayService.error(errorsWithoutDuplicateError);
        }
      })
    );
  }
}
